import { render, staticRenderFns } from "./versions.vue?vue&type=template&id=4bb3ea05&scoped=true&"
import script from "./versions.vue?vue&type=script&lang=js&"
export * from "./versions.vue?vue&type=script&lang=js&"
import style0 from "./versions.vue?vue&type=style&index=0&id=4bb3ea05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3ea05",
  null
  
)

export default component.exports